<template>
  <c-view>
    <c-page>
      <c-navbar></c-navbar>
      <c-content>
        <c-images :img-items="imgItems"></c-images>
      </c-content>
      <c-footer :horizontal="false">
        <c-footer class="no-border">
          <c-title-line class="title-full" title="选择条数"></c-title-line>
        </c-footer>
        <c-footer class="no-border">
          <c-button-recharge v-for="item in rechargeMessage" :key="item.id"
                             :title="item.title" :desc="item.desc" :commend="item.commend"
                             @click.native="rechargeItemClick(item)"
          ></c-button-recharge>
        </c-footer>
      </c-footer>
    </c-page>
    <transition name="slide-right" mode="out-in">
      <router-view></router-view>
    </transition>
  </c-view>
</template>
<style lang="scss" scoped>
  @import "./index";
  
  .no-border {
    border: none !important;
  }
  
  .title-full {
    flex: 1
  }
</style>
<script>
  import RechargeMessage from '../../../../model/rechage/message'
  import CButtonRecharge from '../../../../components/c-button/recharge/index'
  import Pay from '../../../../model/pay'
  import debounce from 'lodash.debounce'

  export default{
    data () {
      return {
        busId: 45,
        rechargeMessage: [],
        imgItems: [],
        rechargeObj: new RechargeMessage(),
        pay: new Pay()
      }
    },
    components: {CButtonRecharge},
    created () {
      this.rechargeObj.loadData(this.busId).then(res => {
        let data = res
        this.rechargeMessage = data.rechargeMessage
        this.imgItems = data.imgItems
      })
    },
    mounted () {},
    beforeDestroy () {},
    methods: {
      rechargeItemClick: debounce(function (itemObj) {
        this.pay.rechargePay(itemObj.id)
      }, 330)
    },
    computed: {},
    events: {}
  }
</script>



// WEBPACK FOOTER //
// index.vue?cc4316ee